import { AppstoreOutlined, BarsOutlined, TableOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import { FC } from 'react';

export type LayoutType = 'list' | 'card' | 'compact-card';

interface LayoutToggleProps {
  layout: LayoutType;
  onChange: (layout: LayoutType) => void;
  className?: string;
}

const LayoutToggle: FC<LayoutToggleProps> = ({ layout, onChange, className }) => {
  return (
    <div className={className}>
      <Radio.Group
        value={layout}
        onChange={(e) => onChange(e.target.value)}
        buttonStyle="solid"
        size="middle"
      >
        <Radio.Button value="list">
          <BarsOutlined />
        </Radio.Button>
        <Radio.Button value="card">
          <AppstoreOutlined />
        </Radio.Button>
        <Radio.Button value="compact-card">
          <TableOutlined />
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default LayoutToggle;
